import { Quote } from "components/molecules/Quote";
import { LuckContent } from "features/daily-holoscope/components/luckContent";
import { VFC } from "react";
import { Image } from "shared/components/atoms/Image";
import DailyHoloscope from "shared/models/daily_holoscope";
import styled from "styled-components";

const Rank = styled.div`
  font-family: HiraMinProN-W6;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 1.18px;
  text-align: center;
  line-height: 28px;
  text-shadow: 0 2px 4px rgba(131, 131, 131, 0.5);
  margin-bottom: 16px;
`;

const ShortSummary = styled.div`
  font-family: HiraMinProN-W6;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.41px;
  text-align: center;
  line-height: 28px;
  text-shadow: 0 2px 4px rgba(131, 131, 131, 0.5);
`;

interface Props {
  dailyHoloscope: DailyHoloscope;
}

export const LuckContents: VFC<Props> = ({ dailyHoloscope }) => {
  const { rank, title, contents } = dailyHoloscope;

  return (
    <>
      <div tw="relative">
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/daily_holoscope/rainbow_rectangle.png`}
          width={688}
          height={280}
          layout="responsive"
          priority
          tw="relative"
        />
        <div tw="absolute inset-0 flex-center flex-col">
          <Rank>{rank}位</Rank>
          <ShortSummary>{title}</ShortSummary>
        </div>
      </div>
      {contents.map((luckContent, index) => {
        const { luckType, rate, body } = luckContent;
        return index % 2 === 0 ? (
          <Quote key={index}>
            <LuckContent
              key={index}
              title={luckType.value}
              luckValue={rate}
              content={body}
            />
          </Quote>
        ) : (
          <LuckContent title={luckType.value} luckValue={rate} content={body} />
        );
      })}
    </>
  );
};
